export interface PPSRConfirmationDialogData {
}
export interface PPSRConfirmationDialogResult {
  readyForSubmission: boolean;
}

